<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <kinva-doc-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import KinvaDocProvider from "../../../../providers/KinvaDocProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import KinvaDocForm from "../KinvaDocForm";
    
    


    export default {
        name: "KinvaDocCreate",
         
        components: { KinvaDocForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'kinva.kinvaDoc.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    identifier: '',
                    title: '',
                    size: 'A4'
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    KinvaDocProvider.createKinvaDoc(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createKinvaDoc)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

